/**
 * Reusable brand logo component. Reads the institute logo URL from the
 * per-deployment env var so white-label replicas don't need a rebuild.
 *
 * White-label rule:
 * - Custom logo set (VITE_INSTITUTE_LOGO_URL): use it in BOTH light and dark.
 *   A dark-colored custom logo would vanish on a dark bg, so back it with a
 *   white chip in dark mode. NEVER swap a custom logo for /logo-dark.png.
 * - Default logo (no custom set): two-img swap to /logo-dark.png in dark mode.
 */
export default function BrandLogo({ className = "", alt }) {
    const customLogo = import.meta.env.VITE_INSTITUTE_LOGO_URL;
    if (customLogo) {
        return (
            <img
                src={customLogo}
                alt={alt || "Logo"}
                className={`${className} dark:bg-white/90 dark:p-1 dark:rounded-md`}
            />
        );
    }
    return (
        <>
            <img src="/logo-square.png" alt={alt || "Logo"} className={`${className} dark:hidden`} />
            <img src="/logo-dark.png" alt={alt || "Logo"} className={`${className} hidden dark:block`} />
        </>
    );
}
